<template>
  <div class="brand-icon" @click="onClick">
    <ImgLazy :image-url="iconUrl" :alt-text="alt" aspect-ratio="1" />
  </div>
</template>

<script>
import ImgLazy from '../images/ImgLazy.vue'

export default {
  components: {
    ImgLazy
  },
  props: {
    iconUrl: {
      type: String,
      required: true
    },
    alt: {
      type: String,
      required: false,
      default: 'brand-icon'
    }
  },
  methods: {
    onClick() {
      this.$emit('click-image')
    }
  }
}
</script>
<style lang="scss" scoped>
.brand-icon {
  @extend %hover-common;
  width: 100%;
  height: 100%;
  max-width: 115px;
  min-width: 0;
  max-height: 115px;
  box-shadow: 0 0 16px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  cursor: pointer;
  padding: 8px;
  background-color: $white;
}
</style>
